import { NavLink } from "react-router-dom";
import { Home, Search, MessagesSquare, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const BottomNav = () => {
  const { user } = useAuth();
  const items = [
    { to: "/", icon: Home, label: "Home", id: "home" },
    { to: "/explore", icon: Search, label: "Find", id: "explore" },
    { to: "/community", icon: MessagesSquare, label: "Community", id: "community" },
    { to: user ? "/dashboard" : "/join", icon: User, label: user ? "Me" : "Join", id: "me" },
  ];
  return (
    <nav data-testid="bottom-nav" className="fixed inset-x-0 bottom-0 z-50 border-t border-[#EAE4DC] bg-[#FAF7F2]/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-xl md:hidden">
      <div className="grid grid-cols-4">
        {items.map(({ to, icon: Icon, label, id }) => (
          <NavLink key={id} to={to} end={to === "/"} data-testid={`bottom-nav-${id}`}
            className={({ isActive }) => `flex flex-col items-center gap-1 py-2.5 text-[11px] transition-colors ${isActive ? "text-pink-600" : "text-stone-500"}`}>
            <Icon className="h-5 w-5" />{label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
